module.exports = __webpack_public_path__ + "static/auth0-image-default-3829f0c318e1b9a43e2195722b9f3891.png";